(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var noneClass = "display_none";
		var successMessage = "Phone number is confirmed.";
		//var errorMessage = "Confirmation has failed. Please try again later.";
		var errorMessage = "Confirmation can not be send. Please check entered phone number.";
		var result = document.getElementById("sendError");

		/* Phone Confirmation */
		//var smsCheck = document.getElementById("smsCapable");
		var phoneNumber = document.getElementById("phoneNumber");
		var container = document.getElementById("confirmation");
		var sendBtn = document.getElementById("sendPhoneConfirmation");
		var confBtn = document.getElementById("confBtn");

		/*if((container.dataset.confirm == 0) && (smsCheck.checked)) {
			showSendBlock();
		} else {
			if(container.dataset.confirm === 1) {
				sendBtn.innerHTML = "Resend Confirmation";
			} else {
				sendBtn.innerHTML = "Resend Confirmation";
				showSendBlock();
				document.getElementById("answer").classList.remove(noneClass);
			}
		}*/

		// send confirmation request
		if(sendBtn) {
			sendBtn.addEventListener("click", function(event) {
				event = event || window.event;
				event.preventDefault();
				
				var divAnswer = document.getElementById("answer");
				var divError  = document.getElementById("sendError");

				// ajax - send phone number
				var phone = phoneNumber.value;
				var url = this.href;

				// TODO: rework to POST in future because GET is insecure for this operation!
                $.get(url, {
                    "phone": phone
                }).done(function (response) {
                    if (divAnswer.classList.contains(noneClass))
                        divAnswer.classList.remove(noneClass);
                }).fail(function (response) {
                    alert("Server has failed to send confirmation code. Please try again later.");
                });
			});
		}

		// confirm SMS code
		if(confBtn) {
			confBtn.addEventListener("click", function(event) {
				event = event || window.event;
				event.preventDefault();

                var phone = phoneNumber.value;
				var code = document.getElementById("smsCode");
				var url = this.href;

				if(code.value) {
                    // TODO: rework to POST in future because GET is insecure for this operation!
                    $.get(url, {
                        "phone": phone,
                        "code": code.value
                    }).done(function (response) {
                        container.classList.add("success");
                        container.innerHTML = successMessage;
                    }).fail(function (response) {
                        result.innerHTML = "Server has failed to check your confirmation code due to wrong code or internal error.";
                    });
				}
			});
		}

		// to change phone number
		if(phoneNumber) {
			let val = phoneNumber.value;

			phoneNumber.addEventListener("blur", function() {
				if(this.value !== val) {
					showSendBlock();
				}
			});
		}

		// click on the checkbox
		/*if(smsCheck) {
			smsCheck.addEventListener("click", function() {
				if((this.checked) && (container.dataset.confirm !== 1)) showSendBlock();
				else hiddeSendBlock();
			});
		}*/
		
		// hidde and show container
		function showSendBlock() { container.classList.remove(noneClass); }
		function hiddeSendBlock() { container.classList.add(noneClass); }

		function sendGetAjax(url, callback) {
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.send();
			xhr.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					//console.log(this.responseText);
					result.innerHTML = null;
					callback(this.responseText);
					return;
				} else {
					result.innerHTML = errorMessage;
					//console.log("Error: " + this.status);
					return;
				}
			}
		}

		/* Change your password */
		var changePassBtn = document.getElementById("changePass");
		var changePassBlock = document.getElementById("showChangePassword");

		if(changePassBtn) {
			changePassBtn.addEventListener("click", function(event) {
				event = event || window.event;
				event.preventDefault();

				changePassBlock.classList.toggle(noneClass);
			});
		}

		// Email confirmed
		emailConfirmed("EmailConfirmed");
		function emailConfirmed(blockID) {
			var block = document.getElementById(blockID);
			var input;
			var email;

			if(block) {
				input = block.previousElementSibling;
				email = input.value || false;

				input.addEventListener("input", function() {
					var value = this.value;

					if(email) {
						if(value !== email) block.style.display = "block";
						else block.style.display = "none";
					}
				});
			}
		}

	});
})();